import HttpFactory from '../factory'

class CustomPDFModule extends HttpFactory {
  async getElements(code) {
    const url = `/custom_pdf/elements/${code}`
    return await this.call(`get`, url)
  }

  async generatePDF(code, data) {
    const url = `/custom_pdf/generate/${code}`
    return await this.call(`post`, url, {code, elements: data});
  }

}

export default CustomPDFModule
